export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Overviews';
export const TEAM_NAME = 'jira-cosmos';
